import { getAuthToken } from '../utils/authSession';
import { getAcceptLanguage } from '../utils/acceptLanguage';
import { SERVICE_ID } from '../config';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.dr-bardawam.com/api/v1';
const AUTH_API_BASE = process.env.REACT_APP_AUTH_API_URL || 'https://api.dr-bardawam.com/api';

/** Endpoints that must stay scoped to Crystal Bardawam (service_id = 2). */
const SERVICE_SCOPED_PREFIXES = [
  '/users/categories',
  '/users/products',
  '/users/offers',
  '/users/cities',
  '/users/orders',
];

function withServiceId(path) {
  if (typeof path !== 'string' || !path.startsWith('/')) return path;

  const qIndex = path.indexOf('?');
  const pathname = qIndex >= 0 ? path.slice(0, qIndex) : path;
  const query = qIndex >= 0 ? path.slice(qIndex + 1) : '';

  const needsService = SERVICE_SCOPED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  if (!needsService) return path;

  const params = new URLSearchParams(query);
  if (!params.has('service_id')) {
    params.set('service_id', String(SERVICE_ID));
  }
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

async function buildHeaders(extraHeaders = {}) {
  const token = await getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Accept-Language': getAcceptLanguage(),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
}

export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${withServiceId(path)}`;
  return fetch(url, {
    ...options,
    headers: await buildHeaders(options.headers),
  });
}

export async function authFetch(path, options = {}) {
  const url = `${AUTH_API_BASE}${path}`;
  return fetch(url, {
    ...options,
    headers: await buildHeaders(options.headers),
  });
}
